import { Content } from "./item/content/content";
import { Icon } from "./item/icon/icon";
import { ListItem } from "./item/item";
import { List } from "./list";
import { ListDivider } from "./list-divider";
const ListItemWithSubComponents = Object.assign(ListItem, { Icon, Content });
const ListWithSubComponents = Object.assign(List, { Item: ListItemWithSubComponents, Divider: ListDivider });
export { ListWithSubComponents as List, List as ListRoot, ListItem, Icon as ListItemIcon, Content as ListItemContent };
